@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed && pageReady) {
  <div class="p-3 flex flex-column flex-auto cf-page" [class.cf-compact]="isMobile">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>Task Types
      </h3></div>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <div class="field mb-4 col-12">
            <label for="classname" class="font-medium">What would you like to do?</label>
            <p-selectbutton [options]="taskOptions" [(ngModel)]="TaskType.tasktype" style="height:50px;">
              <ng-template let-item pTemplate>
                <span [class]="item.icon" style="margin-right:10px"></span><br>
                <span>{{item.label}}</span>
              </ng-template>
            </p-selectbutton>
          </div>
          <div class="field mb-4 col-12">
            <label for="classname" class="font-medium">What would you like to call this task?</label>
            <input [(ngModel)]="TaskType.name" id="classname" type="text" [ngStyle]="{'border-color': (taskNameValid==false) ? '#FF0000':''}"  pInputText>
          </div>
          @if (!taskNameValid) {
            <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Task Type name.</div>
          }
          <div class="field mb-4 col-12">
            <label for="classname" class="font-medium">You can add a description here, this may help you remember what the task does in the future.</label>
            <input [(ngModel)]="TaskType.desc" id="classname" type="text" [ngStyle]="{'border-color': (taskDescValid==false) ? '#FF0000':''}"  pInputText>
          </div>
          @if (TaskType.tasktype == 'REMIND' || TaskType.tasktype == 'COLLECT') {
            <div class="field mb-4 col-12">
              <label for="classname" class="font-medium">How many days before the booking would you like this sent?</label>
              <p-inputnumber id="length" [style]="{'width': '300px'}"  [(ngModel)]="TaskType.noofdays" [showButtons]="true" max="365" min="1" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
            </div>
          }
          @if (TaskType.tasktype == 'FEEDBACK' || TaskType.tasktype == 'THANK') {
            <div class="field mb-4 col-12">
              <label for="classname" class="font-medium">How many days after the booking would you like this sent?</label>
              <p-inputnumber id="length" [style]="{'width': '300px'}"  [(ngModel)]="TaskType.noofdays" [showButtons]="true" max="365" min="1" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
            </div>
          }
          <div class="field mb-4 col-12">
            <label for="classname" class="font-medium">What Email Template would you like to use for this task?</label><br>
            <p-select [options]="EmailTemplates"  placeholder="Select a template" [showClear]="true" [(ngModel)]="TaskType.emailtemplate" optionLabel="name"></p-select>
          </div>
          @if (!taskEmailTemplateValid) {
            <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select an Email for this task.<br></div>
          }
          <div style="width:100%; clear:both;"></div>
          @if (TaskType.tasktype == 'COLLECT') {
            <div class="field mb-4 col-12">
              <label for="classname" class="font-medium">If Payment is not made, how regularly would you like to send this reminder</label>
              <p-select [options]="taskfrequency" [(ngModel)]="TaskType.frequency" optionLabel="label" optionValue="value" placeholder="Select a Frequency"></p-select>
            </div>
          }
          @if (TaskType.tasktype == 'THANK') {
            <div>
              <div class="field mb-4 col-12">
                <label for="discountType" class="font-medium">What voucher type would you like to send the customer for their next visit?</label>
                <p-selectbutton id="discountType" [style]="{'width': '300px'}" [options]="stateOptionsDiscount" [(ngModel)]="TaskType.discounttype" ></p-selectbutton>
              </div>
              @if (TaskType.discounttype == 'FIXED') {
                <div class="field mb-4 col-12">
                  <label for="autogeneratenumber" class="font-medium">Discount Amount</label>
                  <p-inputnumber id="autogeneratenumber" [style]="{'width': '300px'}" mode="currency" currency="{{CurrencySymbol}}" [ngModel]="TaskType.discountamount == null ? 0: TaskType.discountamount" (ngModelChange)="TaskType.discountamount = $event" [showButtons]="true" max="10000" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                </div>
              }
              @if (TaskType.discounttype == 'PERCENTAGE') {
                <div class="field mb-4 col-12">
                  <label for="autogeneratenumber" class="font-medium">Discount Amount</label>
                  <p-inputnumber id="autogeneratenumber" [style]="{'width': '300px'}" suffix="%" [ngModel]="TaskType.discountamount == null ? 0: TaskType.discountamount" (ngModelChange)="TaskType.discountamount = $event" [showButtons]="true" max="100" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                </div>
              }
              <div class="field mb-4 col-12">
                <label for="ddlPackage" class="font-medium">Number of months that the vouchers is valid for from receipt</label>
                <p-inputnumber  [style]="{'width': '300px'}" [(ngModel)]="TaskType.voucherexpiry" [showButtons]="true" max="12" min="1" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
              </div>
            </div>
          }
          @if (needSelectedPackages) {
            <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select some packages.<br></div>
          }
          <div style="clear:both;width:100%"></div>
          <div><p-selectbutton id="allpackages" [style]="{'width': '450px','margin-bottom' : '15px'}" [options]="stateOptionsPackages" [(ngModel)]="allPackages"></p-selectbutton>
        </div>
        <div style="clear:both;width:100%"></div>
        @if (allPackages == false) {
          <div style="width:100%">
            <div style="margin-bottom:10px;">Please add the packages that you would like this task to be assigned to.</div>
            <div class="surface-card p-4 shadow-2 border-round" style="width:100%;">
              <div class="grid formgrid p-fluid" style="width:100%">
                @if (!isMobile) {
                  <div class="col-12 md:col-6 drag-column">
                    <label class="font-medium">Available Packages</label>
                    <p-table [value]="packages">
                      <ng-template #header>
                        <tr>
                          <th style="width:90%">Name</th>
                          <th style="width:10%">&nbsp;</th>
                        </tr>
                      </ng-template>
                      <ng-template #body let-package>
                        <tr pDraggable="packages" (onDragStart)="dragStart($event, package)" (onDragEnd)="dragEnd()">
                          <td>{{package.name}}</td>
                          <td>
                            <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToList(package)">
                              <span class="pi pi-angle-right"></span>
                            </button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                    @if (packages == null) {
                      <div style="padding: 15px;">
                        <i>No packages available, add some <a href="packageedit/0">here</a></i>
                      </div>
                    }
                  </div>
                }
                <div class="cf-col col-12 md:col-6 drop-column" pDroppable="packages" (onDrop)="drop()">
                  <!-- On a phone the Available list is this dropdown instead - see addPicked. -->
                  @if (isMobile) {
                    <div class="cf-add-row">
                      <p-select [options]="packages" [(ngModel)]="picked['packages']" [ngModelOptions]="{standalone: true}" optionLabel="name" placeholder="Add a package"
                      [filter]="true" filterBy="name" appendTo="body" emptyMessage="None available"></p-select>
                      <button pButton pRipple type="button" class="p-button-success"
                        [disabled]="picked['packages'] == null" (click)="addPicked('packages', AddToList)"><span class="p-button-icon p-button-icon-left pi pi-plus" aria-hidden="true"></span><span class="p-button-label">Add</span></button>
                      </div>
                    }
                    <label class="font-medium">Selected Packages</label>
                    <p-table [value]="selectedPackages">
                      <ng-template  #header let-columns>
                        <tr>
                          <th style="width:90%">Name</th>
                          <th style="width:10%">&nbsp;</th>
                        </tr>
                      </ng-template>
                      <ng-template #body let-package let-columns="columns" let-index="rowIndex">
                        <tr>
                          <td>{{package.name}}</td>
                          <td>
                            <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="RemoveFromList(package)">
                              <span class="pi pi-angle-left"></span>
                            </button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="col-12">
            <button  pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
              <span class="pi pi-pencil" style="margin-right:8px;"></span>
            Save Changes</button>
            &nbsp;
            <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
              <span class="pi pi-times" style="margin-right:8px;"></span>
            Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}